import * as analytics from 'Utils/analytics';
//import { LazyInitializer } from 'Utils/LazyInitializer';

var hasSectionDependencies = hasSection();
//import iFrameResize from 'iFrameResizer';
var iFrameResize = undefined;

async function getComponents() {
    /* Dynamic Imports: https://webpack.js.org/guides/code-splitting/#dynamic-imports
     * The reason we need default is that since webpack 4, when importing a CommonJS module, 
     * the import will no longer resolve to the value of module.exports, 
     * it will instead create an artificial namespace object for the CommonJS module.
     * For more information on the reason behind this, read webpack 4: import() and CommonJs.
     * https://medium.com/webpack/webpack-4-import-and-commonjs-d619d626b655
    */

    let moduleName = 'iFrameResizer';
    console.log('>>> hotelListSimple.js >>> moduleName: ' + moduleName);
    //const iFrameResize = await import(moduleName); // throw error: Cannot find module 'moduleName'
    //const iFrameResize = await import('iFrameResizer');
    //const { iFrameResize } = await import('iFrameResizer');
    const { default: iFrameResize } = await import('iFrameResizer');
    console.log('>>> hotelListSimple.js >>> loaded: ' + moduleName);
    return {
        iFrameResize
    }
}


AppLoader.ready(async function () {
    if (hasSectionDependencies) {
        //console.log('>>> hotelListSimple.js >>> init: AppLoader.ready');
        if (typeof iFrameResize == "undefined") {
            //console.log('>>> hotelListSimple.js >>> init: iFrameResizer == "undefined"');
            let components = await getComponents();
            //console.log('>>> hotelListSimple.js >>> done: getComponents');
            iFrameResize = components.iFrameResize;
        }
        //console.log('>>> hotelListSimple.js >>> done: AppLoader.ready');
        InitializeHotelListSimple();
    }
});


function SectionElement() {
    return document.querySelector('#hotelListSimple');
}

function hasSection() {
    let result =  (SectionElement() != null);
    //console.log('>>> hotelListSimple.js >>> hasSection: ' + result);
    return result;
}

function InitializeHotelListSimple() {

    //console.log('>>> hotelListSimple.js >>> iFrameResize: ', iFrameResize);
    //console.log('>>> hotelListSimple.js >>> global.iFrameResize: ', global.iFrameResize);

    if (typeof global.iFrameResize == "undefined" && typeof iFrameResize == "function") {
        global.iFrameResize = iFrameResize;
    }

    AppLoader.raf(function () {
        if (typeof iFrameResize == "function") {
            iFrameResize();
        } else if (typeof global.iFrameResize == "function") {
            global.iFrameResize();
        }
    });


    let $section = $(SectionElement());
    let $hotelCards = $section.hasClass('hotel-cards--simple') ? $section : $section.find('.hotel-cards--simple');

    let sectionData = null;
    if (AppData && AppData.sections && AppData.sections['hotelListSimple']) {
        sectionData = AppData.sections['hotelListSimple'];
    }

    if ($hotelCards && $hotelCards.length > 0 && sectionData) {
        track_view_item_list($hotelCards, sectionData);

        let $morItems = $hotelCards.find('.more-items');
        if ($morItems && $morItems.length > 0) {
            $morItems.on('more-items.show-more-items', function (event, data) {
                //console.log('>>> more-items arguments: ', arguments);
                track_view_item_list($hotelCards, sectionData);
            });
        }
    }

}


function get_hotel_item(hotelCard) {
    return {
        Id: hotelCard.HotelId,
        PageId: hotelCard.PageId,
        Name: hotelCard.Name,
        DestinationName: hotelCard.DestinationName,
        Concept: !hotelCard.Concept ? null : {
            Id: hotelCard.Concept.Id,
            Code: hotelCard.Concept.Code,
            Name: hotelCard.Concept.Name,
        }
        //hotel.ArrivalDate
    };
}

function track_view_item_list($hotelCards, sectionData) {
    if (!sectionData.ga_event || sectionData.ga_event == '') {
        return;
    }
    if (sectionData.ga_event != 'view_item_list') {
        return;
    }

    let $items = $hotelCards.find('.hotel-card-simple');

    //console.log('>>> more-items $items', $items);
    var items = sectionData.Items;

    var hotelList = [];
    if ($items && $items.length > 0) {
        $items.each(function (i, el) {
            var $el = $(el);
            if ($el.is(":visible")) {
                //var ga_item = $el.data('ga_item');
                //if (ga_item) {
                //    hotelList.push(ga_item);
                //}

                let hotelId = $el.attr('data-hotelId');
                if (hotelId && hotelId != '') {
                    hotelId = parseInt(hotelId);
                    if (!isNaN(hotelId)) {
                        let matches = $.grep(items, function (item, i) {
                            return hotelId == item.HotelId;
                        });
                        if (matches && matches.length > 0) {
                            let ga_item = get_hotel_item(matches[0]);
                            if (ga_item) {
                                hotelList.push(ga_item);
                            }
                        }
                    }
                }
            }
        });
    }
    //console.log('>>> more-items hotelList', hotelList);

    let ga_itemList = analytics.getItemList();
    let list_id = AppData.CurrentPageId;
    let list_name = '';
    let destinationName = '';

    if (ga_itemList) {
        if (ga_itemList.item_list_id && ga_itemList.item_list_id != '') {
            list_id = ga_itemList.item_list_id;
        }

        if (ga_itemList.item_list_name && ga_itemList.item_list_name != '') {
            list_name = ga_itemList.item_list_name;
        }
    }

    if (sectionData.ga_list_id && sectionData.ga_list_id != '') {
        //if (list_id && list_id != '') {
        //    list_id += '_' + sectionData.ga_list_id;
        //} else {
        //    list_id = sectionData.ga_list_id;
        //}
        list_id = sectionData.ga_list_id;
    }

    if (sectionData.ga_list_name && sectionData.ga_list_name != '') {
        //if (list_name && list_name != '') {
        //    list_name += '_' + sectionData.ga_list_name;
        //} else {
        //    list_name = sectionData.ga_list_name;
        //}
        list_name = sectionData.ga_list_name;
    }

    let departureAirportCode = '';
    let totalPersons = 0;
    let hotelOnly = true;
    let isDirectFlight = false;

    if (typeof searchViewModel != "undefined" && searchViewModel) {
        departureAirportCode = searchViewModel.DepartureAirportCode();
        totalPersons = searchViewModel.TotalPersons();
        hotelOnly = searchViewModel.HotelOnly();
        isDirectFlight = searchViewModel.IsDirectFlight();
    }    

    // let currentPage = searchViewModel ? searchViewModel.CurrentPage() : null;
    // if (currentPage) {
    //     destinationName = currentPage.Title();
    // }

    let itemList = {
        id: list_id,
        name: list_name,
        DepartureAirportCode: departureAirportCode,
        DestinationName: destinationName,
        TotalPersons: totalPersons,
        HotelOnly: hotelOnly,
        IsDirectFlight: isDirectFlight
    };
    analytics.trackViewItemList(hotelList, itemList);
}